<template>
  <b-button :disabled="disabled" variant="danger" @click="$emit('click')">
    {{$t('Delete')}}
  </b-button>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    name: "DeleteButton",
  }
</script>

<style lang="scss" scoped>

</style>
